import { dataProps } from './properties'

export const setEmployeeLoanList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setEmployeeLoanData = (state, payload) => {
    state.props = payload.response
} 

export const setEmployeeLoanBalance = (state, payload) => {
    state.props.loan_balance = payload
}

export const resetEmployeeLoanData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/employeeLoan/mutations.js